import React, { useMemo } from 'react';

import InputForm from '../../../../../components/form/InputForm';
import TotalCategoryTable from '../../TotalCategoryTable';
import { CATEGORY_TYPE } from '../../../../../constants/service/app/categoryConstants';
import CategoryListTabBox from '../../common/CategoryListTabBox';

const TotalCategory = (props) => {
  const {
    form,
    isShow,
    totalCategoryDataSource,
    totalCategoryTabType,
    totalCategoryRowSelection,
    setTotalCategoryTabType,
  } = props;

  const searchKeyword = form.getFieldValue('category-search-keyword');

  const searchedTotalCategory = useMemo(
    () =>
      totalCategoryDataSource?.filter((mainCategory) => {
        // 키워드를 입력하지 않을 시, 일반형 전체 리스트 출력
        if (!searchKeyword) return true;
        // 카테고리 검색 키워드 정규표현식을 만들어 대소문자 구분하지 않고 검색을 가능하게 함
        const categorySearchKeywordRegEx = new RegExp(searchKeyword, 'gi');
        return categorySearchKeywordRegEx.test(mainCategory.name);
      }),
    [totalCategoryDataSource, searchKeyword],
  );

  const totalGeneralCategoryDataSource = useMemo(
    () => searchedTotalCategory?.filter((mainCategory) => mainCategory.type === CATEGORY_TYPE.GENERAL),
    [searchedTotalCategory],
  );
  const totalEmphasisCategoryDataSource = useMemo(
    () => searchedTotalCategory?.filter((mainCategory) => mainCategory.type === CATEGORY_TYPE.EMPHASIS),
    [searchedTotalCategory],
  );

  return (
    isShow && (
      <CategoryListTabBox
        title={<div className="main-title">카테고리 리스트</div>}
        categoryTabType={totalCategoryTabType}
        setCategoryTabType={setTotalCategoryTabType}
      >
        <InputForm
          className="category-search-input-wrap"
          form={form}
          initialValue={null}
          placeholder="카테고리명을 입력해주세요"
          onChange={() => {}}
          isEditable
          name="category-search-keyword"
        />
        <TotalCategoryTable
          totalCategoryDataSource={
            totalCategoryTabType === String(CATEGORY_TYPE.GENERAL)
              ? totalGeneralCategoryDataSource
              : totalEmphasisCategoryDataSource
          }
          rowSelection={totalCategoryRowSelection}
        />
      </CategoryListTabBox>
    )
  );
};

export default TotalCategory;
